/**
 * O numero do teclado proprio (M10, M12), sem desenho: o que cada tecla faz e
 * como o texto vira numero e volta a texto com o ponto de milhar.
 */

/**
 * O que a tecla faz com o texto do numero: digito, uma virgula so, uma casa
 * decimal (o medidor anda de decimo em decimo) e apagar.
 */
export function teclar(atual: string, tecla: string, casas = 1): string {
  if (tecla === 'apagar') return atual.slice(0, -1);
  if (tecla === ',') return atual.includes(',') ? atual : `${atual === '' ? '0' : atual},`;
  if (!/^\d$/.test(tecla)) return atual;
  const [inteira = '', decimal] = atual.split(',');
  if (decimal !== undefined) return decimal.length >= casas ? atual : `${atual}${tecla}`;
  if (inteira.length >= 7) return atual;
  return inteira === '0' ? tecla : `${atual}${tecla}`;
}

/** "4832,5" -> 4832.5; vazio ou so virgula -> null. */
export function numeroDoTeclado(texto: string): number | null {
  if (texto === '' || texto === ',') return null;
  const n = Number(texto.replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

/** "4832,5" -> "4.832,5": o ponto de milhar enquanto digita (p.59). */
export function textoDoTeclado(texto: string): string {
  if (texto === '') return '0';
  const [inteira = '0', decimal] = texto.split(',');
  const comPontos = inteira.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return decimal === undefined ? comPontos : `${comPontos},${decimal}`;
}
